import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollHandler() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          return;
        }
      }
      window.scrollTo(0, 0);
    };

    const timer = setTimeout(handleScroll, 100);

    return () => clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}
